import { render, staticRenderFns } from "./warehouses.vue?vue&type=template&id=d71dcd62"
import script from "./warehouses.vue?vue&type=script&lang=js"
export * from "./warehouses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports